import React from 'react';
import { Platform, Switch } from 'react-native';

export function AdminToggle({
  value,
  onValueChange,
  activeColor = '#2ecc71',
  inactiveColor = '#888',
}) {
  if (Platform.OS === 'web') {
    return (
      <button
        type="button"
        role="switch"
        aria-checked={value}
        onClick={() => onValueChange(!value)}
        style={{
          position: 'relative',
          width: 46,
          height: 26,
          borderRadius: 13,
          border: 'none',
          backgroundColor: value ? activeColor : inactiveColor,
          cursor: 'pointer',
          padding: 0,
          flexShrink: 0,
          outline: 'none',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: 3,
            left: value ? 23 : 3,
            width: 20,
            height: 20,
            borderRadius: 10,
            backgroundColor: '#ffffff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.35)',
            transition: 'left 0.15s ease',
          }}
        />
      </button>
    );
  }

  return (
    <Switch
      value={value}
      onValueChange={onValueChange}
      trackColor={{ false: inactiveColor, true: activeColor }}
      thumbColor="#f4f4f5"
    />
  );
}
